import { render, staticRenderFns } from "./yuangong.vue?vue&type=template&id=ca7e663a&scoped=true"
import script from "./yuangong.vue?vue&type=script&lang=js"
export * from "./yuangong.vue?vue&type=script&lang=js"
import style0 from "./yuangong.vue?vue&type=style&index=0&id=ca7e663a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7e663a",
  null
  
)

export default component.exports